function initMomentsCarousel(grid) {
  const items = Array.from(grid.querySelectorAll('.moments-item'));
  if (!items.length) return;
  items[0].classList.add('is-active');

  const setActiveCard = () => {
    const gridRect = grid.getBoundingClientRect();
    const gridCenter = gridRect.left + gridRect.width / 2;
    let activeItem = items[0];
    let minDistance = Number.POSITIVE_INFINITY;

    for (const item of items) {
      const rect = item.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      const distance = Math.abs(center - gridCenter);
      if (distance < minDistance) {
        minDistance = distance;
        activeItem = item;
      }
    }

    for (const item of items) {
      item.classList.toggle('is-active', item === activeItem);
    }
  };

  let rafId = null;
  const onScroll = () => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      setActiveCard();
    });
  };

  grid.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setActiveCard);
  requestAnimationFrame(setActiveCard);
}

function setupMomentsCarousels() {
  if (window.matchMedia('(min-width: 769px)').matches) return;
  document.querySelectorAll('.moments-section .moments-grid').forEach(initMomentsCarousel);
}

function initDifferenceCarousel(gallery) {
  const items = Array.from(gallery.querySelectorAll('.ss-video-card'));
  if (!items.length) return;

  items[0].classList.add('is-active');

  const setActiveCard = () => {
    const galleryRect = gallery.getBoundingClientRect();
    const galleryCenter = galleryRect.left + galleryRect.width / 2;
    let activeItem = items[0];
    let minDistance = Number.POSITIVE_INFINITY;

    for (const item of items) {
      const rect = item.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      const distance = Math.abs(center - galleryCenter);
      if (distance < minDistance) {
        minDistance = distance;
        activeItem = item;
      }
    }

    for (const item of items) {
      item.classList.toggle('is-active', item === activeItem);
    }
  };

  let rafId = null;
  const onScroll = () => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      setActiveCard();
    });
  };

  gallery.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setActiveCard);
  requestAnimationFrame(setActiveCard);
}

function setupDifferenceCarousels() {
  if (window.matchMedia('(min-width: 769px)').matches) return;
  document.querySelectorAll('.ss-difference-section .ss-video-gallery').forEach(initDifferenceCarousel);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setupMomentsCarousels();
    setupDifferenceCarousels();
  });
} else {
  setupMomentsCarousels();
  setupDifferenceCarousels();
}
